// BEACON — FAQ + contact split. A hairline accordion on the left and a
// sticky, accent-tinted contact card on the right so the escape hatch is
// always in view. The card links to the section's contact link, or to the
// help center when there is none (`ctx.contactHref`, `ctx.contactCta`).
function itemHtml(ctx, it) {
    return `<div class="fq-acc">
  <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="p-${it.idx}">
    <span>${it.q}</span>
    ${ctx.showIcon ? ctx.icon : ''}
  </button>
  <div class="fq-panel" id="p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
</div>`;
}
const beacon = {
    id: 'beacon',
    name: 'Beacon',
    tag: 'FAQ + contact split',
    styleTag: 'Supportive',
    description: 'An accordion beside a sticky contact card, so the escape hatch is always in view. The layout support teams ask for.',
    layout: 'accordion',
    defaultAccent: '#dd5784',
    darkDefault: false,
    catSupport: 'none',
    features: ['accordion'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <div class="fq-main">
    <h2 class="fq-title">${ctx.title}</h2>
    ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
    <div class="fq-list">
${ctx.items.map((it) => itemHtml(ctx, it)).join('\n')}
    </div>
  </div>
  <div class="fq-card">
    <span class="fq-cardic">${ctx.svg.headset}</span>
    <h3 class="fq-cardtitle">${ctx.t('contactTitle')}</h3>
    <p class="fq-cardsub">${ctx.t('contactText')}</p>
    <a class="fq-cta" href="${ctx.contactHref}">${ctx.contactCta}${ctx.svg.arrowRight}</a>
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:920px;margin:0 auto;display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:44px;align-items:start}
.FQM .fq-title{margin:0 0 10px;font-family:${ctx.v.head};font-size:32px;font-weight:600;line-height:1.12;letter-spacing:-0.01em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0 0 22px;font-size:15.5px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-list{border-top:1px solid ${ctx.v.border}}
.FQM .fq-acc{border-bottom:1px solid ${ctx.v.border}}
.FQM .fq-qbtn{display:flex;width:100%;align-items:center;justify-content:space-between;gap:14px;padding:17px 2px;font-size:16px;font-weight:500;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-qbtn .fq-ic{font-size:12px;color:${ctx.v.accent}}
.FQM .fq-a{padding:0 30px 18px 2px;font-size:15px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-card{position:sticky;top:24px;padding:30px 28px;border-radius:${ctx.v.radiusWrap};background:${ctx.v.soft}}
.FQM .fq-cardic{display:grid;place-items:center;width:44px;height:44px;border-radius:999px;background:${ctx.v.accent};color:#ffffff}
.FQM .fq-cardic .fq-svg{width:17px;height:17px}
.FQM .fq-cardtitle{margin:16px 0 6px;font-family:${ctx.v.head};font-size:20px;font-weight:650;color:${ctx.v.ink}}
.FQM .fq-cardsub{margin:0 0 18px;font-size:14.5px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-cta{display:inline-flex;align-items:center;gap:9px;padding:11px 20px;border-radius:999px;background:${ctx.v.accent};color:#ffffff;font-size:14px;font-weight:600;text-decoration:none}
.FQM .fq-cta .fq-svg{width:11px;height:11px}
`;
        return { html, css };
    },
};
export default beacon;
